import React, { useEffect, useState } from "react";

const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

const isIOS = () =>
  /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;

// Applique le bon manifest (fichier statique) pour que « l'écran d'accueil »
// ouvre le bon espace. Fichiers réels = installation fiable (pas de blob).
const MANIFEST = { games: "/manifest.json", caisse: "/manifest-caisse.json", admin: "/manifest-admin.json" };
function applyManifest(kind) {
  const link = document.querySelector('link[rel="manifest"]');
  if (link) link.setAttribute("href", MANIFEST[kind] || "/manifest.json");
}

/**
 * Bouton « Ajouter à l'écran d'accueil » (PWA).
 * - Disparaît une fois l'appli installée (mode standalone ou événement appinstalled).
 * - Sur Android/Chrome : déclenche l'invite native.
 * - Sur iOS : affiche les instructions (Safari n'a pas d'invite programmatique).
 */
export default function InstallButton({ kind = "games", className = "", label = "📲 Ajouter à l'écran d'accueil" }) {
  const [deferred, setDeferred] = useState(null);
  const [installed, setInstalled] = useState(isStandalone());
  const [showIosHint, setShowIosHint] = useState(false);
  const ios = isIOS();

  useEffect(() => {
    applyManifest(kind);
    const onBIP = (e) => { e.preventDefault(); setDeferred(e); };
    const onInstalled = () => { setInstalled(true); setDeferred(null); };
    window.addEventListener("beforeinstallprompt", onBIP);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onBIP);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, [kind]);

  if (installed) return null;                 // déjà installé → le bouton disparaît
  if (!deferred && !ios) return null;         // pas installable (déjà ajouté / navigateur non compatible)

  const onClick = async () => {
    if (deferred) {
      deferred.prompt();
      const { outcome } = await deferred.userChoice;
      if (outcome === "accepted") setInstalled(true);
      setDeferred(null);
    } else if (ios) {
      setShowIosHint((v) => !v);
    }
  };

  return (
    <div className="relative inline-block">
      <button onClick={onClick} data-testid="install-button"
        className={className || "text-sm font-bold bg-white/90 text-ink px-4 py-2 rounded-full shadow"}>
        {label}
      </button>
      {showIosHint && (
        <div className="absolute z-50 mt-2 left-1/2 -translate-x-1/2 w-64 bg-white text-ink text-xs rounded-2xl shadow-2xl p-3 text-center">
          Sur iPhone : appuie sur <b>Partager</b> <span aria-hidden>􀈂</span> puis <b>« Sur l'écran d'accueil »</b>.
        </div>
      )}
    </div>
  );
}
